import React, { useCallback, useState } from "react";
import SideMenu from "../../components/SideMenu";
import Footer from "../../components/Footer";
import Quotes from "../../components/Quotes";
import QuoteCard from "../../components/Swap/QuoteCard";
import OperationHistory from "../../components/Swap/OperationHistory";
import SwapService from "../../services/Swap/swapService";

const PAIR_OPTIONS = ["USDT/BRL"];

function getUserEmail() {
  return sessionStorage.getItem("emailUser") || "";
}

/**
 * Tela do cliente do swap mesa-cliente (Task 19). Consome os endpoints da
 * Task 15 (`/v1/baas/swap/...`) via `swapService.js`, que usa
 * `CreateSetupBackend()` — o token reforçado (`X-BaaS-Authorization`) vai
 * junto sozinho pelo interceptador de `services/config/config.js`.
 *
 * Esqueleto igual ao de `src/pages/Transfers/Ted/index.jsx`: `#userPage` →
 * `SideMenu` → `.contentData > .contentScroll` → `Quotes` → título →
 * conteúdo → `Footer`.
 */
function Swap() {
  const [pair, setPair] = useState(PAIR_OPTIONS[0]);
  const [side, setSide] = useState("Buy");
  const [quantity, setQuantity] = useState("");
  const [quote, setQuote] = useState(null);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [quoteError, setQuoteError] = useState("");
  const [historyRefreshToken, setHistoryRefreshToken] = useState(0);

  const email = getUserEmail();

  const requestQuote = useCallback(
    async (event) => {
      if (event) event.preventDefault();

      if (!quantity || Number(quantity) <= 0) {
        setQuoteError("Informe uma quantidade válida.");
        return;
      }

      setQuoteLoading(true);
      setQuoteError("");
      try {
        const response = await SwapService.createQuote({
          email,
          pair,
          side,
          quantity: Number(quantity),
        });
        setQuote(response.data);
      } catch (error) {
        setQuoteError(
          error?.response?.data?.message ||
            "Não foi possível obter a cotação.",
        );
        setQuote(null);
      } finally {
        setQuoteLoading(false);
      }
    },
    [email, pair, side, quantity],
  );

  const handleLocked = useCallback(() => {
    setHistoryRefreshToken((token) => token + 1);
  }, []);

  const handleRequestNewQuote = useCallback(() => {
    setQuote(null);
  }, []);

  return (
    <section id="userPage" className="userPage transactionPage swapPage">
      <SideMenu />

      <div className="contentData">
        <div className="contentScroll">
          <Quotes />
          <p className="breadcrumb">
            <b>
              <span className="textPrimary">Início</span> | Swap
            </b>
          </p>
          <br />
          <p className="title">
            <span style={{ fontWeight: "normal" }}>Swap |</span> Cotar e
            travar
          </p>
          <br />

          <div className="contentSubData">
            {!quote && (
              <section className="swapCard">
                <p className="swapCard__title">Nova cotação</p>

                <form onSubmit={requestQuote}>
                  <div className="swapForm">
                    <div className="swapField">
                      <label className="swapLabel" htmlFor="swapPair">
                        Par
                      </label>
                      <select
                        id="swapPair"
                        className="swapInput"
                        value={pair}
                        onChange={(event) => setPair(event.target.value)}
                      >
                        {PAIR_OPTIONS.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="swapField">
                      <label className="swapLabel" htmlFor="swapSide">
                        Lado
                      </label>
                      <select
                        id="swapSide"
                        className="swapInput"
                        value={side}
                        onChange={(event) => setSide(event.target.value)}
                      >
                        <option value="Buy">Compra</option>
                        <option value="Sell">Venda</option>
                      </select>
                    </div>

                    <div className="swapField">
                      <label className="swapLabel" htmlFor="swapQuantity">
                        {/* A unidade fica no rótulo porque a quantidade é
                            SEMPRE na cripto, nos dois lados. Sem isso o
                            cliente digita o valor em reais na compra. */}
                        Quantidade ({pair.split("/")[0]})
                      </label>
                      <input
                        id="swapQuantity"
                        className="swapInput"
                        type="number"
                        min="0"
                        step="0.000001"
                        placeholder="0,000000"
                        value={quantity}
                        onChange={(event) => setQuantity(event.target.value)}
                      />
                    </div>
                  </div>

                  {quoteError && <p className="swapError">{quoteError}</p>}

                  <div className="swapFormActions">
                    <button
                      type="submit"
                      className="swapBtn swapBtn--primary"
                      disabled={quoteLoading}
                    >
                      {quoteLoading ? "Cotando..." : "Cotar"}
                    </button>
                  </div>
                </form>
              </section>
            )}

            {quote && (
              <QuoteCard
                quote={quote}
                email={email}
                onRequestNewQuote={handleRequestNewQuote}
                onLocked={handleLocked}
              />
            )}

            <OperationHistory
              email={email}
              refreshToken={historyRefreshToken}
            />
          </div>

          <Footer />
        </div>
      </div>
    </section>
  );
}

export default Swap;
